import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { getChildObject } from './form-data.utility';
import { takeUntil } from 'rxjs/operators';
import { InverterSearchModel } from '@intellio/shared/models';
import { InvertersService } from '@intellio/shared/services';

export const prefillInverterDetailsHook = (destroyed$, inverterService: InvertersService): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    field.form
      .get(field.key as string)
      ?.valueChanges.pipe(takeUntil(destroyed$))
      .subscribe((newVal) => {
        if (newVal) {
          const p = field.parent;
          const mfgObj = getChildObject(p, 'inverterManufacturer');
          const mfg = p.parent.formControl.get(mfgObj.key);
          const modelNumber = newVal;
          const inverterMatches = inverterService.searchInverters(new InverterSearchModel({
            Manufacturer: mfg.value,
            ModelNumber: modelNumber,
            Take:1
          }));
          inverterMatches.subscribe((response) => {
            const inverter = response?.data?.data?.[0];
            if (inverter) {
              const ratingkWObj = getChildObject(p, 'inverterRatingkW');
              const ratingkW = p.formControl.get(ratingkWObj.key);
              ratingkW.setValue(inverter.kWRating);

              const ratingkVAObj = getChildObject(p, 'inverterRatingKVA');
              const ratingkVA = p.formControl.get(ratingkVAObj.key);
              ratingkVA.setValue(inverter.kVARating);

              const ratedVoltageObj = getChildObject(p, 'inverterRatingVoltage');
              const ratedVolts = p.formControl.get(ratedVoltageObj.key);
              ratedVolts.setValue(inverter.voltageRating);

              const ratedDCVoltageObj = getChildObject(
                p,
                'inverterDCRatedVoltage'
              );

              const ratedDCVolts = p.formControl.get(ratedDCVoltageObj?.key);
              ratedDCVolts?.setValue(inverter.nominalDCVoltage);

              const ratedDCCircuitVoltsObj = getChildObject(
                p,
                'inverterDCCircuitVoltage'
              );
              const ratedDCCircuitVolts = p.formControl.get(
                ratedDCCircuitVoltsObj?.key
              );
              ratedDCCircuitVolts?.setValue(inverter.ratingCircuitVoltage);

              const inverterIsCertifiedObj = getChildObject(
                p,
                'inverterIsCertified'
              );
              const inverterIsCertified = p.formControl.get(
                inverterIsCertifiedObj?.key
              );
              inverterIsCertified?.setValue(inverter.ieeE1547Certified);

              // When we are pre-filling an inverter
              // ensure that hidden inverter fields
              // remain in a disabled state
              const mfgOtherObj = getChildObject(p, 'inverterManufacturerOther');
              const mfgOther = p.formControl.get(mfgOtherObj.key);
              mfgOther.disable();

              const modelOtherObj = getChildObject(p, 'inverterModelOther');
              const modelOther = p.formControl.get(modelOtherObj.key);
              modelOther.disable();

              const cutSheetObj = getChildObject(p, 'inverterCutSheet');
              const cutSheet = p.formControl.get(cutSheetObj?.key);
              cutSheet?.disable();
            }
          });
        }
      });
  };
};
